
document.addEventListener("codeblackbelt:frequently-bought-together:rendered", function(){ 
    cloneCheckboxes();
    cloneInfo();
    addScrollWrapper();
    copyPriceAfterChangeVariant();
})

function cloneCheckboxes() {
    let productList = document.querySelectorAll('.cbb-frequently-bought-products li');
    Array.from(productList).forEach(function(li, i){
        let plusIcon = li.querySelector('.cbb-frequently-bought-plus-icon');
        if(plusIcon != null) {
            plusIcon.classList.add('hide');
        }   
        
        let checkboxInner = document.createElement('label');
        checkboxInner.classList.add('cbb-frequently-bought-product-checkbox-inner');

        let checkboxE = document.createElement('input');
        checkboxE.type = 'checkbox';
        checkboxE.dataset.index = i;
        checkboxE.checked = true;
        checkboxE.classList.add('cbb-frequently-bought-product-checkbox');

        let checkboxMark = document.createElement('span');
        checkboxMark.classList.add('cbb-frequently-bought-product-checkbox-mark');

        checkboxInner.appendChild(checkboxE);
        checkboxInner.appendChild(checkboxMark);

        let imageDiv = li.querySelector('.cbb-frequently-bought-product-image');
        imageDiv.appendChild(checkboxInner);
    });
    addActionCloneCheckboxes();
}

function addActionCloneCheckboxes() {
    let checkboxCloneList = document.querySelectorAll('.cbb-frequently-bought-products .cbb-frequently-bought-product-checkbox');
    Array.from(checkboxCloneList).forEach(function(checkbox, i){
        checkbox.addEventListener('change', function(e){
            let parentLi = e.target.parentElement.parentElement;
            if(e.target.checked) {
                parentLi.classList.remove('disabled');
            }else {
                parentLi.classList.add('disabled');
            }
            let checkboxInput = document.querySelector('.cbb-frequently-bought-selector-list li:nth-child(' + (i + 1) + ') .cbb-frequently-bought-selector-input');
            checkboxInput.click();
        });
    });
}

function cloneInfo() {
    let infoItems = document.querySelectorAll('.cbb-frequently-bought-selector-list li');
    Array.from(infoItems).forEach(function(item, i){
        let productInput = item.querySelector('.cbb-frequently-bought-selector-input');
        let productId = productInput.name.replace('product_', '');

        let itemElements = item.innerHTML;
        itemElements.replaceAll('AUD', '');
        let productWrapper = document.querySelector('.cbb-frequently-bought-products li:nth-child(' + (i + 1) + ')');
        productWrapper.dataset.productId = productId;

        let infoInner = document.createElement('div');
        infoInner.classList.add('cbb-frequently-bought-product-info');
        infoInner.innerHTML = itemElements;
        productWrapper.appendChild(infoInner);

        // remove link on the image
        let imageLink = productWrapper.querySelector('.cbb-frequently-bought-product-image-link');
        if(imageLink != null) {
            let image = imageLink.querySelector('.cbb-frequently-bought-product-image');
            productWrapper.insertBefore(image, productWrapper.children[0]);
            imageLink.remove();
        }

        // remove checkbox duplicate
        let checkboxDuplicate = productWrapper.querySelector('.cbb-frequently-bought-selector-input');
        checkboxDuplicate.remove();
        // remove regular price if it's empty
        let regularPrice = productWrapper.querySelector('.cbb-frequently-bought-selector-label-regular-price');
        if(regularPrice.innerText == '') {
            regularPrice.remove();
        }
        // remove currency
        let moneyItems = productWrapper.querySelectorAll('.money');
        Array.from(moneyItems).forEach(function(item, i){
            let itemText = item.innerText;
            let itemNewText = itemText.replace('AUD', '');
            item.innerText = itemNewText;
        });
    });

    addActionCloneSelector();
}
function addActionCloneSelector() {
    let productList = document.querySelector('.cbb-frequently-bought-products');
    let cloneSelectors = document.querySelectorAll('.cbb-frequently-bought-product .cbb-recommendations-variant-select');
    Array.from(cloneSelectors).forEach(function(select, i) {
        select.addEventListener('change', function(e){
            e.preventDefault();
            let value = e.target.value;
            let li_parent = e.target.closest('.cbb-frequently-bought-product');
            let li_index = Array.prototype.indexOf.call(productList.children, li_parent);
            
            let realSelector = document.querySelector('.cbb-frequently-bought-selector-list li:nth-child(' + (li_index + 1) + ') .cbb-recommendations-variant-select');
            
            realSelector.value = value;
            realSelector.dispatchEvent(new Event("change"));
        });
    });
}

function addScrollWrapper() {
    let parentContainer = document.querySelector('.cbb-frequently-bought-recommendations-container');
    let productList = document.querySelector('.cbb-frequently-bought-products');
    let form = document.querySelector('.cbb-frequently-bought-form');
    let scrollWrapper = document.createElement('div');
    scrollWrapper.classList.add('cbb-frequently-bought-scroller');
    scrollWrapper.appendChild(productList);
    parentContainer.insertBefore(scrollWrapper, form);
}

function copyPriceAfterChangeVariant() {
    
    document.addEventListener('codeblackbelt:frequently-bought-together:variant-change', function(e){
        
        let productId = e.detail.productId;
        let li_parent = document.querySelector('.cbb-frequently-bought-products li[data-product-id="' + productId + '"]') 
        let infoWrapper = li_parent.querySelector('.cbb-frequently-bought-product-info');
        
        let item_regular_price = li_parent.querySelector('.cbb-frequently-bought-selector-label-regular-price');
        let item_sale_price = li_parent.querySelector('.cbb-frequently-bought-selector-label-sale-price');
        let item_compare_price = li_parent.querySelector('.cbb-frequently-bought-selector-label-compare-at-price');

        if(item_regular_price != null) {
            item_regular_price.remove();
        }
        if(item_sale_price != null) {
            item_sale_price.remove();
        }
        if(item_compare_price != null) {
            item_compare_price.remove();
        }

        let li_real = document.querySelector('.cbb-frequently-bought-selector-list li:has(.cbb-frequently-bought-selector-input[name="product_' + productId + '"])')
        let new_regular_price = li_real.querySelector('.cbb-frequently-bought-selector-label-regular-price');
        let new_sale_price = li_real.querySelector('.cbb-frequently-bought-selector-label-sale-price');
        let new_compare_price = li_real.querySelector('.cbb-frequently-bought-selector-label-compare-at-price');

        if(new_regular_price != null) {
            let clone_regular = new_regular_price.cloneNode(true);
            infoWrapper.append(clone_regular);
        }
        if(new_sale_price != null) {
            let clone_sale = new_sale_price.cloneNode(true);
            infoWrapper.append(clone_sale);
        }   
        if(new_compare_price != null) {
            let clone_compare = new_compare_price.cloneNode(true);
            infoWrapper.append(clone_compare);
        }
        // remove currency
        let moneyItems = infoWrapper.querySelectorAll('.money');
        Array.from(moneyItems).forEach(function(item, i){
            let itemText = item.innerText;
            let itemNewText = itemText.replace('AUD', '');
            item.innerText = itemNewText;
        });
    });
}